export const ROLE_HOME_MAP = {
  Owner: "/cdashboard",
  Catalog_Manager: "/cdashboard",
  Finance_Manager: "/financeportal",
  Customer_Success_Manager: "/CustomerSuccessTable",
  Sales: "/sales-product-catalog",
  Dashboard: "/trezi-dashboard",
};
